import React from 'react';
import { TreeSelect as AntTreeSelect } from 'antd-v5';
import downImg from '@/common/images/down.png';
import clearImg from '@/common/images/clear.png';
import selectedImg from '@/common/images/greenSelected.png';
import './style.less';
function TreeSelect(props) {
  const { value, allowClear = true, ...nativeProps } = props;

  return (
    <AntTreeSelect
      {...nativeProps}
      className='ui-tree-select'
      value={value}
      allowClear={
        allowClear
          ? { clearIcon: <img src={clearImg} alt='clear' style={{ width: 16, height: 16 }} /> }
          : false
      }
      optionFilterProp='label'
      suffixIcon={<img src={downImg} alt='down' style={{ width: 16, height: 16 }} />}
      dropdownClassName='ui-tree-select-dropdown'
      // optionRender={(option) => {
      //   console.log('option: ', option);
      //   return (
      //     <div
      //       style={{
      //         display: 'flex',
      //         alignItems: 'center',
      //         justifyContent: 'space-between',
      //         overflow: 'hidden',
      //       }}
      //     >
      //       <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      //         {option.label}
      //       </span>
      //       {option.value === value && (
      //         <img
      //           src={selectedImg}
      //           alt='selected'
      //           style={{ width: 16, height: 16, marginLeft: 4 }}
      //         />
      //       )}
      //     </div>
      //   );
      // }}
    />
  );
}
export default TreeSelect;
